module.exports = __webpack_public_path__ + "static/media/A4 Folder and Paper Mockups 4.1606df00.jpg";